import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';

import planCuentaService from '../../../service/administracion/planCuentaService';
import gradoService from '../../../service/administracion/gradoService';
import columnaBalanceService from '../../../service/administracion/columnaBalanceService';
import monedaService from '../../../service/administracion/monedaService';
import tipoCambioService from '../../../service/administracion/tipoCambioService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            grados: [],
            columnasBalance: [],
            monedas: [],
            tipoCuenta: [],
            tiposCambio: [],
            debe: [],
            haber: [],
            tipoAnalisis: [],
            mayorGrado: [],
            filter: {
                idGrado: 0,
                cuentaContable: '',
                nombre: '',
                idMoneda: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    handleClearFilters = async () => {
        var filter = {
            idGrado: 0,
            cuentaContable: '',
            nombre: '',
            idMoneda: 0,
            ...FILTER
        };
        filter.pageSize = 50;
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            var filter = { ...this.state.filter, ...FILTER };
            filter.pageSize = 50;
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        var filter = { ...this.state.filter, [property]: value };
        filter.pageSize = 50;
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await planCuentaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Plan de Cuenta.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await planCuentaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Plan de Cuenta.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await planCuentaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await planCuentaService.eliminar(values);
            else
                response = await planCuentaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            activeKey: '1',
            cuentaContable: '',
            idGrado: 0,
            idColumnaBase: 0,
            idMoneda: 0,
            idTipoPlan: 0,
            idTipoCambio: 0,
            idTipoAnalisis: 0,
            estadoAnalisis: false,
            estadoProyecto: false,
            estadoAjuste: false,
            grados: [],
            tipoCuenta: [],
            columnasBalance: [],
            monedas: [],
            tipoAnalisis: [],
            tiposCambio: [],
            listaComprobanteDetalle: [],
            debe: [],
            haber: [],
        }
    }

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.grados = this.state.grados;
        formValues.columnasBalance = this.state.columnasBalance;
        formValues.monedas = this.state.monedas;
        formValues.tiposCambio = this.state.tiposCambio;
        formValues.tipoCuenta = this.state.tipoCuenta;
        formValues.debe = this.state.debe;
        formValues.haber = this.state.haber;
        formValues.tipoAnalisis = this.state.tipoAnalisis;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await planCuentaService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.grados = this.state.grados;
            response.columnasBalance = this.state.columnasBalance;
            response.monedas = this.state.monedas;
            response.tiposCambio = this.state.tiposCambio;
            response.tipoCuenta = this.state.tipoCuenta;
            response.debe = this.state.debe;
            response.haber = this.state.haber;
            response.listaComprobanteDetalle = response.cuentaDetalles;
            response.activeKey = '1';
            response.tipoAnalisis = this.state.tipoAnalisis;

            this.setState({ visible: true, formValues: response });
        }
    };

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await planCuentaService.registrar(values);
            else
                response = await planCuentaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleAgregarDetalle = () => {

        if (this.state.formValues.activeKey === "1")
            this.handleAddDetalle();
    };

    handleAddDetalle = () => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        listaComprobanteDetalle.push({
            identifier: global.fetchUniqueCode(),
            idDebe: 0,
            idHaber: 0,
            porcentaje: 0,
            flagInterno: false
        });
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        });
    };

    handleRemoverDetalle = (id) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
        });
    }



    async componentDidMount() {
        this._initPagination({ ...this.state.filter, pageSize: 50 }, planCuentaService.paginacion);
        this.setState({ filter: { ...this.state.filter, pageSize: 50 } });

        const grados = await gradoService.listar();
        const columnasBalance = await columnaBalanceService.listar();
        const monedas = await monedaService.listar();
        const tiposCambio = await tipoCambioService.listar();
        const tipoCuenta = await planCuentaService.listarTipoCuenta();
        const debeHaber = await planCuentaService.listar();
        const tipoAnalisis = await planCuentaService.listarTipoAnalisis();
        const mayorGrado = await planCuentaService.listarPorMayorGrado({ idGrado: 1 });

        this.setState({
            loadingSource: false,
            grados: grados ? grados : [],
            columnasBalance: columnasBalance ? columnasBalance : [],
            monedas: monedas ? monedas : [],
            tiposCambio: tiposCambio ? tiposCambio : [],
            tipoCuenta: tipoCuenta ? tipoCuenta : [],
            debe: debeHaber ? debeHaber : [],
            haber: debeHaber ? debeHaber : [],
            tipoAnalisis: tipoAnalisis ? tipoAnalisis : [],
            mayorGrado: mayorGrado ? mayorGrado : []

        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Plan de Cuenta"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, pageSize: 50  })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    planesCuenta={this.state.planesCuentaAutocomplete}
                    grados={this.state.grados}
                    monedas={this.state.monedas}
                    mayorGrado={this.state.mayorGrado}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverDetalle={this.handleRemoverDetalle}

                />
            </div>
        );
    }
}  